import * as types from "./actionTypes"

export function fetchPlanShipmentData() {
    return {
        type: types.FETCH_PLAN_SHIPMENT_DATA,
    }
}

export function fetchPlanShipmentDataSuccess(data) {
    return {
        type: types.FETCH_PLAN_SHIPMENT_DATA_SUCCESS,
        payload: data,
    }
}

export function fetchTotalPlannedCar() {
    return {
        type: types.FETCH_TOTAL_PLANNED_CAR_DATA,
    }
}

export function fetchTotalPlannedCarSuccess(data) {
    return {
        type: types.FETCH_TOTAL_PLANNED_CAR_DATA_SUCCESS,
        payload: data,
    }
}

export function updatePlanCount(plan) {
    return {
        type: types.UPDATE_PLAN_COUNT,
        payload: plan,
    }
}
export function updatePlanCountSuccess() {
    return {
        type: types.UPDATE_PLAN_COUNT_SUCCESS,
    }
}
export function setForcastingCalculations(data) {
    return {
        type: types.SET_FROCASTING_CALCULATIONS,
        payload: data,
    }
}
